import preloadChunks from '@/routes/preloadChunks.util';

const contactRoutes = [
  {
    path: 'contacts',
    lazy: async () => ({
      Component: (await preloadChunks['contacts.main']()).default,
    }),
    children: [{ path: ':contactId' }],
  },
];

export default contactRoutes;
